import { SHIPPING_COMPANY } from 'swag-common/interfaces';
import { GiveawayLinkStatus } from './giveaway.constants';
export const CSV_COLUMNS = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  COUNTRY: 'Country',
  STATE: 'State',
  EMAIL: 'Email',
  ZIP: 'Zip',
  ADDRESS: 'Address',
  CITY: 'City',
  UNIT: 'Unit (Optional)',
  PHONE: 'Phone number (mandatory for overseas)'
};
const {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  ADDRESS,
  CITY,
  COUNTRY,
  PHONE,
  STATE,
  UNIT,
  ZIP
} = CSV_COLUMNS;
export const CSV_CONTACT_COLUMNS = {
  [FIRST_NAME.toLocaleLowerCase()]: FIRST_NAME,
  [LAST_NAME.toLocaleLowerCase()]: LAST_NAME,
  [EMAIL.toLocaleLowerCase()]: EMAIL,
  [COUNTRY.toLocaleLowerCase()]: COUNTRY,
  [STATE.toLocaleLowerCase()]: STATE,
  [CITY.toLocaleLowerCase()]: CITY,
  [ADDRESS.toLocaleLowerCase()]: ADDRESS,
  [UNIT.toLocaleLowerCase()]: UNIT,
  [ZIP.toLocaleLowerCase()]: ZIP,
  [PHONE.toLocaleLowerCase()]: PHONE
};
export let SHIPOUT_STATUSES = /*#__PURE__*/function (SHIPOUT_STATUSES) {
  SHIPOUT_STATUSES["SAVED"] = "SAVED";
  SHIPOUT_STATUSES["SCHEDULED"] = "SCHEDULED";
  SHIPOUT_STATUSES["SHIPMENT_CALCULATION_PROGRESS"] = "SHIPMENT_CALCULATION_PROGRESS";
  SHIPOUT_STATUSES["SHIPMENT_CALCULATED"] = "SHIPMENT_CALCULATED";
  SHIPOUT_STATUSES["SHIPMENT_REQUEST_PROGRESS"] = "SHIPMENT_REQUEST_PROGRESS";
  SHIPOUT_STATUSES["SHIPMENT_REQUESTED"] = "SHIPMENT_REQUESTED";
  SHIPOUT_STATUSES["SHIPPED"] = "SHIPPED";
  SHIPOUT_STATUSES["DELIVERED"] = "DELIVERED";
  SHIPOUT_STATUSES["SHIPMENT_CALCULATION_ERROR"] = "SHIPMENT_CALCULATION_ERROR";
  SHIPOUT_STATUSES["SHIPMENT_IN_PROGRESS"] = "SHIPMENT_IN_PROGRESS";
  SHIPOUT_STATUSES["REJECTED"] = "REJECTED";
  SHIPOUT_STATUSES["APPROVED"] = "APPROVED";
  SHIPOUT_STATUSES["PENDING"] = "PENDING";
  SHIPOUT_STATUSES["CANCELLED"] = "CANCELLED";
  SHIPOUT_STATUSES["CANCELLED_ON_WAREHOUSE"] = "CANCELLED_ON_WAREHOUSE";
  return SHIPOUT_STATUSES;
}({});
export const SHIPOUT_STATUSES_TITLES = {
  [SHIPOUT_STATUSES.SAVED]: 'SAVED',
  [SHIPOUT_STATUSES.SCHEDULED]: 'Scheduled',
  [SHIPOUT_STATUSES.SHIPMENT_CALCULATION_PROGRESS]: 'Shipment Calculation In Progress',
  [SHIPOUT_STATUSES.SHIPMENT_CALCULATED]: 'Shipment Calculated',
  [SHIPOUT_STATUSES.SHIPMENT_REQUEST_PROGRESS]: 'Sending data to warehouse',
  [SHIPOUT_STATUSES.SHIPMENT_REQUESTED]: 'Shipment Requested',
  [SHIPOUT_STATUSES.CANCELLED]: 'Cancelled',
  [SHIPOUT_STATUSES.CANCELLED_ON_WAREHOUSE]: 'Cancelled on warehouse',
  [SHIPOUT_STATUSES.SHIPPED]: 'Shipped',
  [SHIPOUT_STATUSES.DELIVERED]: 'Delivered',
  [SHIPOUT_STATUSES.REJECTED]: 'Rejected',
  [SHIPOUT_STATUSES.APPROVED]: 'Approved',
  [SHIPOUT_STATUSES.PENDING]: 'Pending',
  [SHIPOUT_STATUSES.SHIPMENT_CALCULATION_ERROR]: 'Shipment calculation error',
  [SHIPOUT_STATUSES.SHIPMENT_IN_PROGRESS]: 'Shipped'
};
export let RECEIVER_STATUSES = /*#__PURE__*/function (RECEIVER_STATUSES) {
  RECEIVER_STATUSES["SAVED"] = "SAVED";
  RECEIVER_STATUSES["SHIPMENT_CALCULATED"] = "SHIPMENT_CALCULATED";
  RECEIVER_STATUSES["SHIPMENT_REQUESTED"] = "SHIPMENT_REQUESTED";
  RECEIVER_STATUSES["SHIPPED"] = "SHIPPED";
  RECEIVER_STATUSES["DELIVERED"] = "DELIVERED";
  RECEIVER_STATUSES["SHIPMENT_LOCATION_ERROR"] = "SHIPMENT_LOCATION_ERROR";
  RECEIVER_STATUSES["SHIPMENT_CALCULATION_ERROR"] = "SHIPMENT_CALCULATION_ERROR";
  RECEIVER_STATUSES["SHIPMENT_REQUESTED_ERROR"] = "SHIPMENT_REQUESTED_ERROR";
  RECEIVER_STATUSES["CANCELLED"] = "CANCELLED";
  RECEIVER_STATUSES["CANCELLED_ON_WAREHOUSE"] = "CANCELLED_ON_WAREHOUSE";
  RECEIVER_STATUSES["COMPLETED"] = "COMPLETED";
  RECEIVER_STATUSES["BACKORDERED"] = "BACKORDERED";
  RECEIVER_STATUSES["UNFULFILLABLE"] = "UNFULFILLABLE";
  RECEIVER_STATUSES["SCHEDULED"] = "SCHEDULED";
  RECEIVER_STATUSES["FAILED"] = "FAILED";
  return RECEIVER_STATUSES;
}({});
export const NOT_SHIPPED_STATUSES = [RECEIVER_STATUSES.SHIPMENT_REQUESTED, RECEIVER_STATUSES.SHIPMENT_REQUESTED_ERROR];
export const RECEIVER_STATUSES_SEQUENCE = [RECEIVER_STATUSES.SAVED, RECEIVER_STATUSES.SHIPMENT_CALCULATED, RECEIVER_STATUSES.SCHEDULED, RECEIVER_STATUSES.SHIPMENT_REQUESTED, RECEIVER_STATUSES.SHIPPED, RECEIVER_STATUSES.DELIVERED];
export const RECEIVER_STATUSES_TITLES = {
  [RECEIVER_STATUSES.SAVED]: 'Saved',
  [RECEIVER_STATUSES.CANCELLED]: 'Cancelled',
  [RECEIVER_STATUSES.SHIPMENT_CALCULATED]: 'Shipment Calculated',
  [RECEIVER_STATUSES.SHIPMENT_REQUESTED]: 'Shipment Requested',
  [RECEIVER_STATUSES.SHIPPED]: 'Shipped',
  [RECEIVER_STATUSES.DELIVERED]: 'Delivered',
  [RECEIVER_STATUSES.SHIPMENT_CALCULATION_ERROR]: 'Shipment calculation error',
  [RECEIVER_STATUSES.SHIPMENT_LOCATION_ERROR]: 'Shipment location error',
  [RECEIVER_STATUSES.SHIPMENT_REQUESTED_ERROR]: 'Shipment requested error',
  [RECEIVER_STATUSES.CANCELLED_ON_WAREHOUSE]: 'Cancelled on warehouse',
  [RECEIVER_STATUSES.BACKORDERED]: 'Backordered',
  [RECEIVER_STATUSES.UNFULFILLABLE]: 'Unfulfillable',
  [RECEIVER_STATUSES.SCHEDULED]: 'Scheduled',
  [RECEIVER_STATUSES.FAILED]: 'Failed'
};
export const SHIPOUT_STATUSES_SEQUENCE = [SHIPOUT_STATUSES.SHIPMENT_CALCULATION_ERROR, SHIPOUT_STATUSES.SAVED, SHIPOUT_STATUSES.SHIPMENT_CALCULATED, SHIPOUT_STATUSES.SCHEDULED, SHIPOUT_STATUSES.SHIPMENT_REQUESTED, SHIPOUT_STATUSES.SHIPMENT_IN_PROGRESS, SHIPOUT_STATUSES.SHIPPED, SHIPOUT_STATUSES.DELIVERED];
export let SHIPOUT_TYPES = /*#__PURE__*/function (SHIPOUT_TYPES) {
  SHIPOUT_TYPES["PULL_FROM_INVENTORY"] = "PULL_FROM_INVENTORY";
  SHIPOUT_TYPES["SHIPOUT"] = "SHIPOUT";
  return SHIPOUT_TYPES;
}({});
export const TRANSFER_TYPE = 'TRANSFER';
export const SHIPMENT_TYPES_DESCRIPTION = {
  [SHIPOUT_TYPES.PULL_FROM_INVENTORY]: 'send to one address',
  [SHIPOUT_TYPES.SHIPOUT]: 'send to multiple addresses',
  [TRANSFER_TYPE]: 'transfer'
};
export const SHIPPING_COMPANIES = [SHIPPING_COMPANY.UPS, SHIPPING_COMPANY.FEDEX, SHIPPING_COMPANY.USPS, SHIPPING_COMPANY.DHL];
export const COMMON_STATUSES_FOR_DISTRIBUTIONS = [RECEIVER_STATUSES.SHIPMENT_REQUESTED, RECEIVER_STATUSES.SHIPMENT_CALCULATED, RECEIVER_STATUSES.SHIPPED, RECEIVER_STATUSES.DELIVERED, RECEIVER_STATUSES.SHIPMENT_REQUESTED_ERROR, RECEIVER_STATUSES.CANCELLED, RECEIVER_STATUSES.CANCELLED_ON_WAREHOUSE, RECEIVER_STATUSES.BACKORDERED, RECEIVER_STATUSES.SCHEDULED];
export const RECEIVER_STATUSES_FOR_DISTRIBUTIONS = [...COMMON_STATUSES_FOR_DISTRIBUTIONS, RECEIVER_STATUSES.COMPLETED];
export const FILTERS_STATUSES_FOR_DISTRIBUTIONS = [...COMMON_STATUSES_FOR_DISTRIBUTIONS, RECEIVER_STATUSES.UNFULFILLABLE];
export const FILTERS_STATUSES_FOR_SHOPIFY_ORDERS = [...COMMON_STATUSES_FOR_DISTRIBUTIONS, RECEIVER_STATUSES.UNFULFILLABLE, RECEIVER_STATUSES.FAILED];
export const RECEIVER_STATUSES_BEFORE_SHIPPED = [
// links
GiveawayLinkStatus.NEW, GiveawayLinkStatus.OPENED, GiveawayLinkStatus.COMPLETED, GiveawayLinkStatus.PENDING_APPROVAL, GiveawayLinkStatus.SHIPMENT_REQUESTED, GiveawayLinkStatus.SHIPMENT_REQUESTED_ERROR,
// shipouts
RECEIVER_STATUSES.SHIPMENT_REQUESTED, RECEIVER_STATUSES.SCHEDULED, RECEIVER_STATUSES.SHIPMENT_CALCULATED, RECEIVER_STATUSES.SHIPMENT_REQUESTED_ERROR];
export let WarehouseStatuses = /*#__PURE__*/function (WarehouseStatuses) {
  WarehouseStatuses["CLOSED"] = "Closed";
  WarehouseStatuses["CANCELLED"] = "Cancelled";
  WarehouseStatuses["BACKORDERED"] = "Backordered";
  WarehouseStatuses["SHIPPED"] = "Shipped";
  return WarehouseStatuses;
}({});
export let BackorderTypes = /*#__PURE__*/function (BackorderTypes) {
  BackorderTypes["all"] = "all";
  BackorderTypes["resolved"] = "resolved";
  BackorderTypes["unresolved"] = "unresolved";
  return BackorderTypes;
}({});
export const BACKORDERED_SELECT_LABELS = {
  [BackorderTypes.all]: 'All orders',
  [BackorderTypes.resolved]: 'Resolved orders',
  [BackorderTypes.unresolved]: 'Unresolved orders'
};
export const CANCEL_ORDER_ERROR = 'Order was cancelled on warehouse';
export const MAXIMUM_NUMBER_OF_ROWS = 10000;
export const RECIPIENTS_LARGE_DIGITS_NUMBER = 3;
export let OverboxSizeNames = /*#__PURE__*/function (OverboxSizeNames) {
  OverboxSizeNames["extraSmall_1"] = "extraSmall_1";
  OverboxSizeNames["extraSmall_2"] = "extraSmall_2";
  OverboxSizeNames["extraSmall_3"] = "extraSmall_3";
  OverboxSizeNames["small"] = "small";
  OverboxSizeNames["smallMedium"] = "smallMedium";
  OverboxSizeNames["smallMedium_2"] = "smallMedium_2";
  OverboxSizeNames["medium"] = "medium";
  OverboxSizeNames["medium_2"] = "medium_2";
  OverboxSizeNames["mediumLarge"] = "mediumLarge";
  OverboxSizeNames["mediumLarge_2"] = "mediumLarge_2";
  OverboxSizeNames["large_1"] = "large_1";
  OverboxSizeNames["large_2"] = "large_2";
  OverboxSizeNames["large_3"] = "large_3";
  OverboxSizeNames["large_4"] = "large_4";
  OverboxSizeNames["largeXL"] = "largeXL";
  OverboxSizeNames["extraLarge_1"] = "extraLarge_1";
  OverboxSizeNames["extraLarge_2"] = "extraLarge_2";
  OverboxSizeNames["extraLarge_3"] = "extraLarge_3";
  OverboxSizeNames["extraLarge_4"] = "extraLarge_4";
  OverboxSizeNames["extraLarge_5"] = "extraLarge_5";
  OverboxSizeNames["umbrella_1"] = "umbrella_1";
  OverboxSizeNames["small_cube"] = "small_cube";
  OverboxSizeNames["medium_cube"] = "medium_cube";
  OverboxSizeNames["small_rectangle"] = "small_rectangle";
  OverboxSizeNames["medium_rectangle"] = "medium_rectangle";
  OverboxSizeNames["tall_rectangle"] = "tall_rectangle";
  OverboxSizeNames["medium_flat_rectangle"] = "medium_flat_rectangle";
  OverboxSizeNames["large_flat_rectangle"] = "large_flat_rectangle";
  OverboxSizeNames["big_rectangle"] = "big_rectangle";
  OverboxSizeNames["giant_flat_rectangle"] = "giant_flat_rectangle";
  OverboxSizeNames["large_rectangle"] = "large_rectangle";
  OverboxSizeNames["giant_rectangle"] = "giant_rectangle";
  OverboxSizeNames["giant_cube"] = "giant_cube";
  return OverboxSizeNames;
}({}); //'14x14x14'

/**
 *  How to calculate Dim Weight
 *  To calculate the dimensional weight of a package you multiply the length by width by height and divide it by the dimensional weight divisor.
 *
 * EXAMPLE
 *  Length: 30 inches
 *  Width: 12 inches
 *  Height: 12 inches
 *  Cubic Size Calculation: 30 x 12 x 12 = 4,320 cubic inches
 *
 *  210 - FedEx Dim Divisor
 *  Dimensional Weight Calculation: 4,320/210 = 20.57 pounds
 **/

export const OVERBOX_SIZES = {
  [OverboxSizeNames.extraSmall_1]: {
    name: 'Extra Small 1',
    length: 6,
    width: 4,
    height: 4,
    dimWeight: 0.457,
    external: {
      length: 6.4,
      width: 4.4,
      height: 4.6,
      dimWeight: 0.6
    },
    isDeprecated: true
  },
  [OverboxSizeNames.extraSmall_2]: {
    name: 'Extra Small 2',
    length: 6,
    width: 6,
    height: 4,
    dimWeight: 0.686,
    external: {
      length: 6.4,
      width: 6.4,
      height: 4.6,
      dimWeight: 0.9
    },
    isDeprecated: true
  },
  [OverboxSizeNames.extraSmall_3]: {
    name: 'Extra Small 3',
    length: 6,
    width: 6,
    height: 5,
    dimWeight: 0.857,
    external: {
      length: 6.4,
      width: 6.4,
      height: 5.6,
      dimWeight: 1.1
    },
    isDeprecated: true
  },
  [OverboxSizeNames.small]: {
    name: 'Small',
    length: 8,
    width: 6,
    height: 4,
    dimWeight: 0.914,
    external: {
      length: 8.4,
      width: 6.4,
      height: 4.6,
      dimWeight: 1.2
    },
    isDeprecated: true
  },
  [OverboxSizeNames.smallMedium]: {
    name: 'Small/Medium',
    length: 10,
    width: 8,
    height: 6,
    dimWeight: 2.286,
    external: {
      length: 10.4,
      width: 8.4,
      height: 6.6,
      dimWeight: 2.7
    },
    isDeprecated: true
  },
  [OverboxSizeNames.smallMedium_2]: {
    name: 'Small/Medium 2',
    length: 12,
    width: 9,
    height: 4,
    dimWeight: 2.057,
    external: {
      length: 12.4,
      width: 9.4,
      height: 10.6,
      dimWeight: 2.6
    },
    isDeprecated: true
  },
  [OverboxSizeNames.medium]: {
    name: 'Medium',
    length: 12,
    width: 9,
    height: 10,
    dimWeight: 5.143,
    external: {
      length: 12.4,
      width: 9.4,
      height: 10.6,
      dimWeight: 5.9
    },
    isDeprecated: true
  },
  [OverboxSizeNames.medium_2]: {
    name: 'Medium 2',
    length: 13,
    width: 11,
    height: 6,
    dimWeight: 4.086,
    external: {
      length: 13.4,
      width: 11.4,
      height: 6.6,
      dimWeight: 4.8
    },
    isDeprecated: true
  },
  [OverboxSizeNames.mediumLarge]: {
    name: 'Medium/Large',
    length: 14,
    width: 10,
    height: 8,
    dimWeight: 5.333,
    external: {
      length: 14.4,
      width: 10.4,
      height: 8.6,
      dimWeight: 6.1
    },
    isDeprecated: true
  },
  [OverboxSizeNames.mediumLarge_2]: {
    name: 'Medium/Large 2',
    length: 16,
    width: 12,
    height: 6,
    dimWeight: 5.486,
    external: {
      length: 16.4,
      width: 12.4,
      height: 6.6,
      dimWeight: 6.4
    },
    isDeprecated: true
  },
  [OverboxSizeNames.large_1]: {
    name: 'Large 1',
    length: 18,
    width: 12,
    height: 12,
    dimWeight: 12.343,
    external: {
      length: 18.4,
      width: 12.4,
      height: 12.6,
      dimWeight: 13.7
    },
    isDeprecated: true
  },
  [OverboxSizeNames.large_2]: {
    name: 'Large 2',
    length: 18,
    width: 18,
    height: 6,
    dimWeight: 9.257,
    external: {
      length: 18.4,
      width: 18.4,
      height: 6.6,
      dimWeight: 10.7
    },
    isDeprecated: true
  },
  [OverboxSizeNames.large_3]: {
    name: 'Large 3',
    length: 18,
    width: 18,
    height: 12,
    dimWeight: 18.514,
    external: {
      length: 18.4,
      width: 18.4,
      height: 12.6,
      dimWeight: 20.3
    },
    isDeprecated: true
  },
  [OverboxSizeNames.large_4]: {
    name: 'Large 4',
    length: 16,
    width: 14,
    height: 8,
    dimWeight: 8.533,
    external: {
      length: 16.4,
      width: 14.4,
      height: 8.6,
      dimWeight: 9.7
    },
    isDeprecated: true
  },
  [OverboxSizeNames.largeXL]: {
    name: 'Large/XL',
    length: 20,
    width: 14,
    height: 12,
    dimWeight: 16.0,
    external: {
      length: 20.4,
      width: 14.4,
      height: 12.6,
      dimWeight: 17.6
    },
    isDeprecated: true
  },
  [OverboxSizeNames.extraLarge_1]: {
    name: 'Extra Large 1',
    length: 22,
    width: 16,
    height: 16,
    dimWeight: 26.819,
    external: {
      length: 22.4,
      width: 16.4,
      height: 16.6,
      dimWeight: 26.4
    },
    isDeprecated: true
  },
  [OverboxSizeNames.extraLarge_2]: {
    name: 'Extra Large 2',
    length: 22,
    width: 22,
    height: 14,
    dimWeight: 32.267,
    external: {
      length: 22.4,
      width: 22.4,
      height: 14.6,
      dimWeight: 34.9
    },
    isDeprecated: true
  },
  [OverboxSizeNames.extraLarge_3]: {
    name: 'Extra Large 3',
    length: 26,
    width: 10,
    height: 4,
    dimWeight: 4.952,
    external: {
      length: 26.4,
      width: 10.4,
      height: 4.6,
      dimWeight: 6
    },
    isDeprecated: true
  },
  [OverboxSizeNames.extraLarge_4]: {
    name: 'Extra Large 4',
    length: 24,
    width: 20,
    height: 12,
    dimWeight: 27.429,
    external: {
      length: 24.4,
      width: 20.4,
      height: 12.6,
      dimWeight: 29.9
    },
    isDeprecated: true
  },
  [OverboxSizeNames.extraLarge_5]: {
    name: 'Extra Large 5',
    length: 28,
    width: 12,
    height: 6,
    dimWeight: 9.6,
    external: {
      length: 28.4,
      width: 12.4,
      height: 6.6,
      dimWeight: 11.1
    },
    isDeprecated: true
  },
  [OverboxSizeNames.umbrella_1]: {
    name: 'Umbrella 1',
    length: 32,
    width: 10,
    height: 6.5,
    dimWeight: 9.905,
    external: {
      length: 32.4,
      width: 10.4,
      height: 7.1,
      dimWeight: 11.4
    },
    isDeprecated: true
  },
  // new boxes
  [OverboxSizeNames.small_cube]: {
    name: 'Small Cube',
    length: 6,
    width: 6,
    height: 6,
    dimWeight: 1.029,
    external: {
      length: 6.4,
      width: 6.4,
      height: 6.6,
      dimWeight: 1.287
    },
    isDeprecated: false
  },
  [OverboxSizeNames.medium_cube]: {
    name: 'Medium Cube',
    length: 7,
    width: 7,
    height: 7,
    dimWeight: 1.633,
    external: {
      length: 7.4,
      width: 7.4,
      height: 7.6,
      dimWeight: 1.982
    },
    isDeprecated: false
  },
  [OverboxSizeNames.small_rectangle]: {
    name: 'Small Rectangle',
    length: 8,
    width: 6,
    height: 5,
    dimWeight: 1.143,
    external: {
      length: 8.4,
      width: 6.4,
      height: 5.6,
      dimWeight: 1.434
    },
    isDeprecated: false
  },
  [OverboxSizeNames.medium_rectangle]: {
    name: 'Medium Rectangle',
    length: 9,
    width: 7,
    height: 4,
    dimWeight: 1.2,
    external: {
      length: 9.4,
      width: 7.4,
      height: 4.6,
      dimWeight: 1.524
    },
    isDeprecated: false
  },
  [OverboxSizeNames.tall_rectangle]: {
    name: 'Tall Rectangle',
    length: 9,
    width: 7,
    height: 8,
    dimWeight: 2.4,
    external: {
      length: 9.4,
      width: 7.4,
      height: 8.6,
      dimWeight: 2.849
    },
    isDeprecated: false
  },
  [OverboxSizeNames.medium_flat_rectangle]: {
    name: 'Medium Flat Rectangle',
    length: 9,
    width: 9,
    height: 4,
    dimWeight: 1.543,
    external: {
      length: 9.4,
      width: 9.4,
      height: 4.6,
      dimWeight: 1.936
    },
    isDeprecated: false
  },
  [OverboxSizeNames.large_flat_rectangle]: {
    name: 'Large Flat Rectangle',
    length: 10,
    width: 10,
    height: 5,
    dimWeight: 2.381,
    external: {
      length: 10.4,
      width: 10.4,
      height: 5.6,
      dimWeight: 2.884
    },
    isDeprecated: false
  },
  [OverboxSizeNames.big_rectangle]: {
    name: 'Big Rectangle',
    length: 12,
    width: 10,
    height: 5,
    dimWeight: 2.857,
    external: {
      length: 12.4,
      width: 10.4,
      height: 5.6,
      dimWeight: 3.439
    },
    isDeprecated: false
  },
  [OverboxSizeNames.giant_flat_rectangle]: {
    name: 'Giant Flat Rectangle',
    length: 12,
    width: 12,
    height: 6,
    dimWeight: 4.114,
    external: {
      length: 12.4,
      width: 12.4,
      height: 6.6,
      dimWeight: 4.832
    },
    isDeprecated: false
  },
  [OverboxSizeNames.large_rectangle]: {
    name: 'Large Rectangle',
    length: 13,
    width: 12,
    height: 7,
    dimWeight: 5.2,
    external: {
      length: 13.4,
      width: 12.4,
      height: 7.6,
      dimWeight: 6.013
    },
    isDeprecated: false
  },
  [OverboxSizeNames.giant_rectangle]: {
    name: 'Giant Rectangle',
    length: 14,
    width: 13,
    height: 7,
    dimWeight: 6.067,
    external: {
      length: 14.4,
      width: 13.4,
      height: 7.6,
      dimWeight: 6.983
    },
    isDeprecated: false
  },
  [OverboxSizeNames.giant_cube]: {
    name: 'Giant Cube',
    length: 14,
    width: 14,
    height: 14,
    dimWeight: 13.067,
    external: {
      length: 14.4,
      width: 14.4,
      height: 14.6,
      dimWeight: 14.416
    },
    isDeprecated: false
  }
};